import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Form, Spin } from "antd";
import { useLocation } from "react-router-dom";

import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import EditBranchForm from "./component/EditBranchForm";
import { apiConfig, labelConfig, staticConfig } from "../systemAdmin.config";

const EditBranch = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { state: selectedBranchKey } = useLocation();

  const [isLoading, setIsLoading] = useState(true);
  const [parentBranch, setParentBranch] = useState([]);
  const [officeTypeOptions, setOfficeTypeOptions] = useState([]);
  const [nearestBranchOptions, setNearestBranchOptions] = useState([]);

  useEffect(() => {
    getTemplate();
  }, []);

  function getTemplate() {
    setIsLoading(true);
    BOM.FetchReqAction({ session }, `${apiConfig.Office}/template`, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        setParentBranch(
          (res?.allowedParents || []).map((el) => ({ value: el.id, label: el.name })),
        );
        setOfficeTypeOptions(
          (res?.allowedOfficeTypes || []).map((el) => ({ value: el.id, label: el.name })),
        );
        setNearestBranchOptions(
          (res?.allowedParents || []).map((el) => ({ value: el.id, label: el.name })),
        );
        setIsLoading(false);
      }
    });
  }

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={labelConfig.editBranch}
        pageItems={staticConfig.editBranch}
      />
      <Spin spinning={isLoading} size="large">
        <EditBranchForm
          parentBranch={parentBranch}
          officeTypeOptions={officeTypeOptions}
          nearestBranchOptions={nearestBranchOptions}
          session={session}
          BOM={BOM}
          apiConfig={apiConfig}
          cnt={cnt}
          setIsLoading={setIsLoading}
          selectedBranchKey={selectedBranchKey}
        />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(EditBranch);
